(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ModeleContratDialogController', ModeleContratDialogController);

    ModeleContratDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'ModeleContrat',   'ServiceVendu'];

    function ModeleContratDialogController ($scope, $stateParams, $uibModalInstance, entity, ModeleContrat,  ServiceVendu) {
        var vm = this;
        vm.modeleContrat = entity;
        vm.serviceautres = ServiceVendu.query({ offset: 0,size: 1000});
        vm.load = function(id) {
            ModeleContrat.get({id : id}, function(result) {
                vm.modeleContrat = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:modeleContratUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.modeleContrat.id !== null) {
                ModeleContrat.update(vm.modeleContrat, onSaveSuccess, onSaveError);
            } else {
                ModeleContrat.save(vm.modeleContrat, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
